const Store = require('../store');
const browserHistory = require('../browserHistory');
const storeUtils = require('./store')(Store);
const localizationUtils = require('./localization')(storeUtils);
const uiUtils = require('./ui')(localizationUtils, browserHistory);
const featuresHelpers = require('./helpers.features')(storeUtils);

const util = Object.assign({},
    require('./base')(storeUtils),
    require('./ajax')(storeUtils),
    require('./claim')(storeUtils),
    require('./component')(storeUtils),
    require('./countries'),
    require('./encoding'),
    require('./events')(storeUtils),
    require('./helpers'),
    featuresHelpers,
    require('./formatters'),
    localizationUtils,
    require('./storage'),
    storeUtils,
    require('./Timer'),
    uiUtils,
    require('./validate')(storeUtils),
    require('./redirect'),
    require('./csv')
);

module.exports = util;